// hooks/useFetchData.js
import { useApi } from "../services/useApi";

export function useFetchData(entity, shouldFetch = false, params = {}) {
  const queryString = new URLSearchParams(params).toString();
  const endpoint = shouldFetch ? `${entity}?${queryString}` : null;

  return useApi(endpoint);
}
